import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useClientAuth } from './context/ClientAuthContext'
import ClientLayout from './components/client/ClientLayout'
import ClientLogin from './pages/client/ClientLogin'
import ClientDashboard from './pages/client/ClientDashboard'
import ClientBots from './pages/client/ClientBots'
import ClientStats from './pages/client/ClientStats'
import ClientRecordings from './pages/client/ClientRecordings'
import ClientBilling from './pages/client/ClientBilling'
import ClientInvoices from './pages/client/ClientInvoices'
import ClientRequests from './pages/client/ClientRequests'

// Public client onboarding (no login). Loaded on demand: it brings its own styles and libraries.
const OnboardingApp = lazy(() => import('./onboarding/OnboardingApp'))

function ClientProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useClientAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full" style={{ minHeight: '100vh', background: '#0f172a' }}>
        <div className="loading-spinner"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function ClientApp() {
  const { isAuthenticated } = useClientAuth()

  return (
    <Routes>
      <Route path="/onboarding" element={
        <Suspense fallback={<div style={{ minHeight: '100vh', background: '#050506' }} />}>
          <OnboardingApp />
        </Suspense>
      } />

      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/" replace /> : <ClientLogin />
      } />

      <Route path="/" element={
        <ClientProtectedRoute>
          <ClientLayout />
        </ClientProtectedRoute>
      }>
        <Route index element={<ClientDashboard />} />
        <Route path="bots" element={<ClientBots />} />
        <Route path="stats" element={<ClientStats />} />
        <Route path="recordings" element={<ClientRecordings />} />
        <Route path="billing" element={<ClientBilling />} />
        <Route path="invoices" element={<ClientInvoices />} />
        <Route path="requests" element={<ClientRequests />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default ClientApp
